module.exports = __webpack_public_path__ + "media/images/biddit-notaire-encheres-6a9caee1fc4aea1977cf45c35cb97bad.jpg";